export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Usage.vue?vue&type=template&id=8d0c793a&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/usage/Usage.vue?vue&type=template&id=8d0c793a&scoped=true&
// module id = 1528
// module chunks = 0